import styled from 'styled-components';
import { Flexbox } from '@hiiretail/synergy-ui';

export const MyGroupsListWrapper = styled(Flexbox)`
  padding: ${({ theme }) => theme.spacing(4)}px;
  background: #fff;
  border-radius: 4px;
  overflow-y: auto;
`;

export const MyGroupsRow = styled(Flexbox)`
  padding: ${({ theme }) => theme.spacing(1)}px ${({ theme }) => theme.spacing(2)}px;
  border-radius: 4px;
  cursor: pointer;
  justify-content: space-between;
  align-items: center;
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;
